// src/config/app.config.js
export const APP_CONFIG = {
  // API Configuration
  API: {
    BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    TIMEOUT: 10000,
  },
  
  // App Information
  APP: {
    NAME: 'Rettzy',
    VERSION: '1.0.0',
    DESCRIPTION: 'Sri Lankan ECommerce Business Management Platform',
  },
  
  // Authentication
  AUTH: {
    TOKEN_KEY: 'authToken',
    USER_KEY: 'user',
    REFRESH_TOKEN_KEY: 'refreshToken',
    TOKEN_EXPIRY_BUFFER: 300000, // 5 minutes before actual expiry
  },
  
  // Google OAuth (if implementing Google signup)
  GOOGLE: {
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  },
  
  // Pagination
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  },
  
  // File Upload
  UPLOAD: {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
    ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'text/csv', 'application/vnd.ms-excel'],
  },
  
  // Date Formats
  DATE_FORMATS: {
    DISPLAY: 'DD/MM/YYYY',
    API: 'YYYY-MM-DD',
    DATETIME: 'DD/MM/YYYY HH:mm',
  },
  
  // Currency
  CURRENCY: {
    CODE: 'LKR',
    SYMBOL: 'Rs.',
    DECIMAL_PLACES: 2,
  },
  
  // Order Status
  ORDER_STATUS: {
    PENDING: 'pending',
    PROCESSING: 'processing',
    PACKED: 'packed',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    CANCELLED: 'cancelled',
    RETURNED: 'returned',
  },
  
  // User Roles
  USER_ROLES: {
    ADMIN: 'admin',
    MANAGER: 'manager',
    STAFF: 'staff',
    VIEWER: 'viewer',
  },
  
  // Default Settings
  DEFAULTS: {
    TIMEZONE: 'Asia/Colombo',
    LANGUAGE: 'en',
    THEME: 'light',
  },
};

// Offline-module order channels: 'offline' (Create Offline Sales Order) and 'pos' (POS terminal)
export const OFFLINE_CHANNELS = ['offline', 'pos'];
export const isOfflineChannel = (channel) => OFFLINE_CHANNELS.includes(channel);

export default APP_CONFIG;